import { useState } from 'react';
import { useNavigate } from 'react-router';
import { useAuth } from '../context/AuthContext';
import { describePasskeyError, isPasskeyCancelled } from '../lib/passkey-errors';

export default function LoginPage() {
  const [error, setError] = useState('');
  const [info, setInfo] = useState('');
  const [loading, setLoading] = useState(false);
  const { loginWithPasskey } = useAuth();
  const navigate = useNavigate();

  const handlePasskeyLogin = async () => {
    setError('');
    setInfo('');
    setLoading(true);

    try {
      await loginWithPasskey();
      void navigate('/');
    } catch (err) {
      if (isPasskeyCancelled(err)) {
        // The user dismissed the prompt: not an error worth alarming about
        setInfo('Sign-in was cancelled. Click the button to try again.');
      } else {
        setError(describePasskeyError(err, 'Sign-in failed. Please try again.'));
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className='flex min-h-screen items-center justify-center bg-gray-100 dark:bg-gray-900'>
      <div className='w-full max-w-md rounded-lg bg-white p-8 shadow-md dark:bg-gray-800'>
        <h1 className='mb-6 text-center text-2xl font-bold text-gray-800 dark:text-white'>
          Admin Panel Login
        </h1>

        <div className='space-y-4'>
          {error && (
            <div className='rounded-md bg-red-50 p-3 text-sm text-red-800 dark:bg-red-900 dark:text-red-200'>
              {error}
            </div>
          )}

          {info && (
            <div className='rounded-md bg-blue-50 p-3 text-sm text-blue-800 dark:bg-blue-900 dark:text-blue-200'>
              {info}
            </div>
          )}

          <button
            type='button'
            onClick={() => void handlePasskeyLogin()}
            disabled={loading}
            className='w-full rounded-md bg-blue-600 px-4 py-2 text-white transition-colors hover:bg-blue-700 disabled:bg-gray-400 dark:bg-blue-500 dark:hover:bg-blue-600 dark:disabled:bg-gray-600'
          >
            {loading ? 'Waiting for passkey...' : 'Sign in with passkey'}
          </button>

          <p className='text-center text-xs text-gray-500 dark:text-gray-400'>
            New administrators need a one-time registration link issued by an existing
            administrator.
          </p>
        </div>
      </div>
    </div>
  );
}
